import type { QueryClient } from '@tanstack/react-query';

export async function invalidateRoutes(queryClient: QueryClient, routes: string[]): Promise<void> {
  await Promise.all(
    routes.map((route) => queryClient.invalidateQueries({ queryKey: [route.split('.')] })),
  );
}
